function parseMongoUri(connectionString) {
  const schemeMatch = connectionString.match(/^(mongodb(?:\+srv)?):\/\//);
  if (!schemeMatch) {
    throw new TypeError(`Unsupported MongoDB connection string: ${connectionString}`);
  }
  const protocol = `${schemeMatch[1]}:`;
  const rest = connectionString.slice(schemeMatch[0].length);
  const afterAuthDelimiter = rest.indexOf("/");
  const authorityEnd = afterAuthDelimiter === -1 ? rest.length : afterAuthDelimiter;
  const authority = rest.slice(0, authorityEnd);
  const tail = rest.slice(authorityEnd);
  let credentials = "";
  let hostsRaw = authority;
  const atIndex = authority.lastIndexOf("@");
  if (atIndex !== -1) {
    credentials = authority.slice(0, atIndex);
    hostsRaw = authority.slice(atIndex + 1);
  }
  let username = "";
  let password = "";
  if (credentials) {
    const colon = credentials.indexOf(":");
    if (colon === -1) {
      username = credentials;
    } else {
      username = credentials.slice(0, colon);
      password = credentials.slice(colon + 1);
    }
  }
  const queryIndex = tail.indexOf("?");
  const pathname = queryIndex === -1 ? tail : tail.slice(0, queryIndex);
  const search = queryIndex === -1 ? "" : tail.slice(queryIndex + 1);
  const hosts = hostsRaw.split(",").map((h) => h.trim()).filter((h) => h.length > 0);
  return { protocol, username, password, hostsRaw, hosts, pathname, search };
}
function mongoHostKey(connectionString) {
  return parseMongoUri(connectionString).hostsRaw;
}
function mongoDisplayName(connectionString) {
  let parsed;
  try {
    parsed = parseMongoUri(connectionString);
  } catch {
    return connectionString;
  }
  const hostnames = parsed.hosts.map((h) => stripPort(h)).filter((h) => h.length > 0);
  if (hostnames.length === 0) {
    return connectionString;
  }
  if (hostnames.length === 1) {
    return hostnames[0];
  }
  const suffix = commonDomainSuffix(hostnames);
  if (suffix) {
    return `${suffix} (${hostnames.length} hosts)`;
  }
  return `${hostnames[0]} (+${hostnames.length - 1})`;
}
function stripPort(host) {
  const lastColon = host.lastIndexOf(":");
  if (lastColon === -1) {
    return host;
  }
  const maybePort = host.slice(lastColon + 1);
  if (/^\d+$/.test(maybePort) && !host.slice(0, lastColon).includes(":")) {
    return host.slice(0, lastColon);
  }
  return host;
}
function commonDomainSuffix(hostnames) {
  const split = hostnames.map((h) => h.split("."));
  const minLen = Math.min(...split.map((s) => s.length));
  let shared = 0;
  for (let i = 1; i <= minLen; i++) {
    const labels2 = split.map((s) => s[s.length - i]);
    if (labels2.every((l) => l === labels2[0])) {
      shared = i;
    } else {
      break;
    }
  }
  if (shared < 2 || shared === minLen) {
    return shared === minLen ? hostnames[0] : "";
  }
  const labels = split[0];
  return labels.slice(labels.length - shared).join(".");
}
export {
  mongoHostKey as a,
  mongoDisplayName as m,
  parseMongoUri as p
};
